import { call, put } from 'redux-saga/effects';
import { setCuentasBancarias, savedCuentaBancaria } from '../../ducks/cuentasBancarias';
import { requestLoadCuentasBancarias, requestSaveCuentaBancaria } from '../requests/cuentasBancarias';

export function* handleLoadCuentasBancarias() {
    try {
        const response = yield call(requestLoadCuentasBancarias);
        const { data } = response;
        yield put(setCuentasBancarias(data));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSaveCuentaBancaria(action) {
    try {
        const response = yield call(requestSaveCuentaBancaria, action.cuentaBancaria);
        const { data } = response;
        yield put(savedCuentaBancaria(data));
        const listResponse = yield call(requestLoadCuentasBancarias);
        yield put(setCuentasBancarias(listResponse.data));
    } catch (error) {
        console.log(error);
    }
}
